import { render, staticRenderFns } from "./LessonCard.vue?vue&type=template&id=34cefa4b&scoped=true"
import script from "./LessonCard.vue?vue&type=script&lang=js"
export * from "./LessonCard.vue?vue&type=script&lang=js"
import style0 from "./LessonCard.vue?vue&type=style&index=0&id=34cefa4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cefa4b",
  null
  
)

export default component.exports